<template>
  <div class="rd-google-map">
    <div id="google-map" class="rd-google-map__model" data-zoom="17" data-x="-73.8396297"
      data-y="40.7187669"></div>
    <ul class="rd-google-map__locations">
      <li data-x="-73.8396297" data-y="40.7187669">
        <p>110-56 Queens Boulevard, Forest Hills,NY 11375 <span>718 520 0911</span></p>
      </li>
    </ul>
  </div>

  <!-- <div>
    <iframe src="https://www.google.com/maps/embed?pb=!1m10!1m8!1m3!1d3023.965907583682!2d-73.83963!3d40.718767!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1545750736810" width="600" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>
  </div> -->
</template>


<script>
  import $ from 'jquery';

  export default {
    name: 'Map',

    mounted(){
      let mapEl = $('#mapScript');
      if(!mapEl.length) {
        this.mapScript = document.createElement('script');
        this.mapScript.setAttribute('id', 'mapScript');
        this.mapScript.setAttribute('src', '//maps.googleapis.com/maps/api/js?key=AIzaSyBinaMPGRM_yx-pAdGQRuEX5E_0wM_DcIA');
        document.body.appendChild(this.mapScript);
      }
    }
  }
</script>


<style scoped>
  
</style>